import { CustomEventWithDetail, html, rune, type Html, View } from 'rune-ts';
import klass from './StorySection.module.scss';
import { staticTypo, typo, typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';
import { ArrowRightIcon } from '../../../../components/atoms/Icon';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import gsap from 'gsap';

export class NavigateToStorySectionCard extends CustomEventWithDetail<{ card_number: number }> {}

const image_urls: Record<number, string> = {
  1: '//s3.marpple.co/files/u_4648126/2024/10/original/4be6b64036c0d502e3b1c778b80f9b32b0fdf2001.png',
  2: '//s3.marpple.co/files/u_4648126/2024/10/original/7dd10e2a0879fb0de92dcd59b9d469a67ec194242.png',
  3: '//s3.marpple.co/files/u_4648126/2024/10/original/d716b9b5571ff571a98c59545070334c6350d71e1.png',
  4: '//s3.marpple.co/files/u_4648126/2024/10/original/a4a0a3b899ed6b63cd9426deb40c50d03d0e17013.png',
  5: '//s3.marpple.co/files/u_4648126/2024/10/original/4678341662b0f06facd978201a792fed6ed4122f4.png',
  6: '//s3.marpple.co/files/u_4648126/2024/10/original/1aa28f8f09f5aae9d36847646195e71b89d9cd5e5.png',
  7: '//s3.marpple.co/files/u_4648126/2024/10/original/9b10053de9bcbdc85541e087272ab1d4e38943966.png',
  8: '//s3.marpple.co/files/u_4648126/2024/10/original/ed2e097af1a78aff9c0fb94c4dd7f9f8a9dae45b7.png',
  9: '//s3.marpple.co/files/u_4648126/2024/10/original/13b1103281003f43305aa05e10f726b775a65e798.png',
  10: '//s3.marpple.co/files/u_4648126/2024/10/original/3fb0205fa024bdf53fcedaece1dd6a7c5c910afe9.png',
};

const link_urls: Record<number, string> = {
  1: 'https://marpple.shop/kr/@/products?cate_list_id=148',
  2: 'https://marpple.shop/kr/@/products?cate_list_id=148', // 변경 예정
  3: 'https://ciety.xyz/find?i=3',
  4: 'https://marpple.shop/kr/@/communities',
  5: 'https://marpple.shop/kr/@/hello_creator',
};

interface StoryContentProps {
  content_number: number;
}

class StoryContent extends View<StoryContentProps> {
  override template({ content_number }: StoryContentProps): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      title: html.preventEscape(ET(`mps2::landing::handmade::story_content_title_${content_number}`)),
      description: html.preventEscape(
        ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}story_content_description_${content_number}`),
      ),
      link: html.preventEscape(ET(`mps2::landing::handmade::story_content_link_${content_number}`)),
    };
    const link_url = link_urls[content_number];

    return html`
      <div class="${klass.story_content}">
        <div class="${typoPcMo({ is_mobile, pc: '24_bold', mo: '16_bold' })}">${texts.title}</div>
        <div class="${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}">${texts.description}</div>
        <a href="${link_url}" target="_blank">
          <div class="${klass.link} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}">
            ${texts.link} ${ArrowRightIcon}
          </div>
        </a>
      </div>
    `;
  }
}

export class StorySection extends View {
  swiper?: Swiper;

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const title = html.preventEscape(ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}story_title`));

    if (is_mobile) {
      return html`
        <section class="${klass.story}">
          <div class="${klass.story_wrapper}">
            <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '40_bold', mo: '28_bold' })}">
              <div class="${staticTypo('bebas_20_bold')}">HANDMADE</div>
              ${title}
            </div>
            <div class="${klass.story_section} ${klass.section_layout_start}">
              <div class="${klass.inner_section_1} ${klass.swiper}">
                <div class="swiper-wrapper">
                  <div class="${klass.swiper_slide} swiper-slide">
                    <img
                      src="${getResizedUrl({
                        url: image_urls[1] ?? '',
                        width: 350 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      alt="핸드메이드 스토리 이미지"
                    />
                  </div>
                  <div class="${klass.swiper_slide} swiper-slide">
                    <img
                      src="${getResizedUrl({
                        url: image_urls[2] ?? '',
                        width: 350 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      alt="핸드메이드 스토리 이미지"
                    />
                  </div>
                </div>
              </div>
              ${new StoryContent({ content_number: 1 })}
            </div>
            <div class="${klass.story_section} ${klass.section_layout_end}">
              <div class="${klass.section_wrapper}">
                <div class="${klass.inner_section_2} ${klass.swiper}">
                  <div class="swiper-wrapper">
                    <div class="${klass.swiper_slide} swiper-slide">
                      <img
                        src="${getResizedUrl({
                          url: image_urls[3] ?? '',
                          width: 350 * 2,
                          quality: 85,
                          format: 'webp',
                        })}"
                        alt="핸드메이드 스토리 이미지"
                      />
                    </div>
                    <div class="${klass.swiper_slide} swiper-slide">
                      <img
                        src="${getResizedUrl({
                          url: image_urls[4] ?? '',
                          width: 350 * 2,
                          quality: 85,
                          format: 'webp',
                        })}"
                        alt="핸드메이드 스토리 이미지"
                      />
                    </div>
                  </div>
                </div>
                ${new StoryContent({ content_number: 2 })}
              </div>
            </div>
            <div class="${klass.story_section} ${klass.section_layout_start}">
              <div class="${klass.inner_section_3}">
                <div class="${klass.top_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls[5] ?? '',
                      width: 280 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                <div class="${klass.bottom_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls[6] ?? '',
                      width: 240 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
              </div>
              ${new StoryContent({ content_number: 3 })}
            </div>
            <div class="${klass.story_section} ${klass.section_layout_end}">
              <div class="${klass.section_wrapper}">
                <div class="${klass.inner_section_4} ${klass.swiper}">
                  <div class="swiper-wrapper">
                    <div class="${klass.swiper_slide} swiper-slide">
                      <img
                        src="${getResizedUrl({
                          url: image_urls[7] ?? '',
                          width: 350 * 2,
                          quality: 85,
                          format: 'webp',
                        })}"
                        alt="핸드메이드 스토리 이미지"
                      />
                    </div>
                    <div class="${klass.swiper_slide} swiper-slide">
                      <img
                        src="${getResizedUrl({
                          url: image_urls[8] ?? '',
                          width: 350 * 2,
                          quality: 85,
                          format: 'webp',
                        })}"
                        alt="핸드메이드 스토리 이미지"
                      />
                    </div>
                  </div>
                </div>
                ${new StoryContent({ content_number: 4 })}
              </div>
            </div>
            <div class="${klass.story_section} ${klass.section_layout_end} ${klass.inner_section_5}">
              <div class="${klass.section_layout_start}">
                <div class="${klass.top_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls[9] ?? '',
                      width: 280 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                ${new StoryContent({ content_number: 5 })}
              </div>
              <div class="${klass.bottom_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls[10] ?? '',
                    width: 327 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
            </div>
          </div>
        </section>
      `;
    } else {
      return html`
        <section class="${klass.story}">
          <div class="${klass.navigation_wrapper}">
            <div class="${klass.navigation}">
              <div class="${staticTypo('bebas_20_bold')}">HANDMADE</div>
              <div class="${klass.nav_items}">
                <div class="${klass.nav_item} ${typo('20_regular')}">
                  ${ET(`mps2::landing::handmade::story_nav_1`)}
                </div>
                <div class="${klass.nav_item} ${typo('20_regular')}">
                  ${ET(`mps2::landing::handmade::story_nav_2`)}
                </div>
                <div class="${klass.nav_item} ${typo('20_regular')}">
                  ${ET(`mps2::landing::handmade::story_nav_3`)}
                </div>
                <div class="${klass.nav_item} ${typo('20_regular')}">
                  ${ET(`mps2::landing::handmade::story_nav_4`)}
                </div>
                <div class="${klass.nav_item} ${klass.last} ${typo('20_regular')}">
                  ${ET(`mps2::landing::handmade::story_nav_5`)}
                </div>
              </div>
            </div>
          </div>

          <div class="${klass.story_wrapper}">
            <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '40_bold', mo: '28_bold' })}">
              ${title}
            </div>
            <div class="${klass.story_section} ${klass.section_layout_start} ${klass.section_1}">
              <div class="${klass.left_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['1'] ?? '',
                    width: 664 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
              <div class="${klass.inner_section_layout}">
                <div class="${klass.right_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls['2'] ?? '',
                      width: 664 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                ${new StoryContent({ content_number: 1 })}
              </div>
            </div>
            <div class="${klass.story_section} ${klass.section_layout_between} ${klass.section_2}">
              <div class="${klass.inner_section_layout}">
                <div class="${klass.left_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls['3'] ?? '',
                      width: 664 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                ${new StoryContent({ content_number: 2 })}
              </div>
              <div class="${klass.right_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['4'] ?? '',
                    width: 664 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
            </div>
            <div class="${klass.story_section} ${klass.section_layout_start} ${klass.section_3}">
              <div class="${klass.left_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['5'] ?? '',
                    width: 432 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
              <div class="${klass.right_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['6'] ?? '',
                    width: 432 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
              ${new StoryContent({ content_number: 3 })}
            </div>
            <div class="${klass.story_section} ${klass.section_layout_between} ${klass.section_4}">
              <div class="${klass.inner_section_layout}">
                <div class="${klass.left_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls['7'] ?? '',
                      width: 664 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                ${new StoryContent({ content_number: 4 })}
              </div>
              <div class="${klass.right_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['8'] ?? '',
                    width: 664 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
            </div>
            <div class="${klass.story_section} ${klass.section_layout_start} ${klass.section_5}">
              <div class="${klass.section_layout_start}">
                <div class="${klass.left_image}">
                  <img
                    src="${getResizedUrl({
                      url: image_urls['9'] ?? '',
                      width: 432 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    alt="핸드메이드 스토리 이미지"
                  />
                </div>
                ${new StoryContent({ content_number: 5 })}
              </div>
              <div class="${klass.right_image}">
                <img
                  src="${getResizedUrl({
                    url: image_urls['10'] ?? '',
                    width: 587 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="핸드메이드 스토리 이미지"
                />
              </div>
            </div>
          </div>
        </section>
      `;
    }
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    if (is_mobile) {
      this.swiper = new Swiper(`.${klass.swiper}`, {
        modules: [Navigation, Autoplay],
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    } else {
      this.pinNavigationSidebar();
    }

    this.delegate('click', `.${klass.nav_items}`, (e: Event) => {
      const el = e.target as Element;
      const nav_items = el.parentNode ? Array.from(el.parentNode.children) : [];
      const idx = nav_items.indexOf(el);

      this.dispatchEvent(NavigateToStorySectionCard, { bubbles: true, detail: { card_number: idx } });
    });
  }

  pinNavigationSidebar() {
    gsap.to(`.${klass.navigation_wrapper}`, {
      scrollTrigger: {
        trigger: `.${klass.story}`,
        pin: `.${klass.navigation_wrapper}`,
        start: 'top top',
        end: 'bottom bottom',
      },
    });
  }
}
